import { User } from '@/models'

export default class UserRepo extends Repository {
  use = User
}
